export function formatPath(path: string[]): string {
  return path
    .filter(Boolean)
    .map(p => p.trim())
    .join('/')
}
